import request from "@/utils/request";
import { invokeParams, doctorParams } from "./params";
// 获取主页轮播图,不分页
export function getHomeCarousel(data) {
  return request({
    url: `/v1/carousel/getList`,
    method: "post",
    data
  });
}

// 删除附件
export function deleteImg(fileName) {
  return request({
    url: "/file/delete?fileName=" + fileName,
    method: "delete"
  });
}

// 获取栏目
export function indexMenuSort() {
  return request({
    url: "/web/index/indexMenuSort",
    method: "get"
  });
}

// 获取菜单
export function indexMenu() {
  return request({
    url: "/web/index/indexMenu",
    method: "get"
  });
}

// 获取根据字典的菜单列表
export function menuLs() {
  return request({
    url: "/web/index/indexMenuNew",
    method: "get"
  });
}

// 功能页
export function featuresInvoke(data) {
  return request({
    url: "/web/features/invoke",
    method: "post",
    data: {
      ...invokeParams,
      ...data
    }
  });
}

// 文章详情
export function getNewsDetail(params) {
  return request({
    url: "/web/content/detail",
    method: "get",
    params
  });
}

// 文章相关动态
export function getNewsAbout(params) {
  return request({
    url: "/web/content/recently",
    method: "get",
    params
  });
}

// 获取文章上下两条
export function getNewsNextAndPre(params) {
  return request({
    url: "/web/content/nextAndPre",
    method: "get",
    params
  });
}

// 科室导航信息
export function getDeptList() {
  return request({
    url: "/web/dept/get",
    method: "get"
  });
}

// 科室导航详情
export function getDeptDetail(params) {
  return request({
    url: "/web/dept/info",
    method: "get",
    params
  });
}

// 专家信息搜索
export function getDoctorList(data) {
  return request({
    url: "/web/doctor/simpleSearch",
    method: "post",
    data: {
      ...doctorParams,
      ...data
    }
  });
}

// 专家信息详情
export function getDoctorDetail(params) {
  return request({
    url: "/web/doctor/showDetail",
    method: "get",
    params
  });
}

// 轮播图获取
export function getBannerList(data) {
  return request({
    url: `/admin/carouselImage/getList`,
    method: "post",
    data,
  });
}

// 栏目管理查询
export function getHomeMenu(data) {
  return request({
    url: "/admin/daliMenuSon/getList",
    method: "post",
    data,
  });
}
export function getmedicalRes(data) {
  return request({
    url: `/admin/medicalResources/getList`,
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/home.js